module.exports = __webpack_public_path__ + "static/media/Primate-House4.21504124.jpg";